var map = {
	"./AboutUs.vue": [
		"4733",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-068859c0"
	],
	"./Admin.vue": [
		"34ab",
		"chunk-60bd36e0",
		"chunk-241764f0"
	],
	"./CoDiver.vue": [
		"6535",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-68335b76"
	],
	"./CoLighting.vue": [
		"799b",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-efa44102"
	],
	"./CoLink.vue": [
		"cef8",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-86b8912c"
	],
	"./ComingSoon.vue": [
		"74cd",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-1a000603"
	],
	"./ContactUs.vue": [
		"7854",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-22373fb8"
	],
	"./ErrorPage.vue": [
		"b599",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-4f6db834"
	],
	"./Hamle.vue": [
		"f674",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-f529db5a"
	],
	"./Home.vue": [
		"bc13",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-563b0b2d"
	],
	"./News.vue": [
		"4b86",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-30697501"
	],
	"./NewsDetail.vue": [
		"3db3",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-54afe301"
	],
	"./PatentDetail.vue": [
		"2634",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-8c246d18"
	],
	"./Patents.vue": [
		"3aa3",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-7e0abe60"
	],
	"./ProductDetail.vue": [
		"7397",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-b9c2b8b2"
	],
	"./Products.vue": [
		"6eb0",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-bce7304a"
	],
	"./ProjectAcusto.vue": [
		"b415",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-4b2f530e"
	],
	"./ProjectDetail.vue": [
		"9f66",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-17af9253"
	],
	"./ProjectElectroOptic.vue": [
		"4868",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-8fac4e64"
	],
	"./ProjectSpectrum.vue": [
		"c745",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-a3f20b6c"
	],
	"./Projects.vue": [
		"7f1d",
		"chunk-60bd36e0",
		"chunk-0e7d38c6",
		"chunk-267260c7"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a2f9";
module.exports = webpackAsyncContext;